import { useState, useCallback } from 'react';

/**
 * Hook to manage generated images in chat
 * Stores images by message index so they can be displayed inline
 */
export function useGeneratedImages() {
  const [generatedImages, setGeneratedImages] = useState(new Map());

  /**
   * Store a generated image for a specific message index
   */
  const storeImage = useCallback((messageIndex, imageData) => {
    setGeneratedImages((prev) => {
      const next = new Map(prev);
      next.set(messageIndex, imageData);
      return next;
    });
  }, []);

  /**
   * Get generated image for a message index
   */
  const getImage = useCallback((messageIndex) => {
    return generatedImages.get(messageIndex);
  }, [generatedImages]);

  /**
   * Clear all stored images
   */
  const clearImages = useCallback(() => {
    setGeneratedImages(new Map());
  }, []);

  /**
   * Remove a specific image
   */
  const removeImage = useCallback((messageIndex) => {
    setGeneratedImages((prev) => {
      const next = new Map(prev);
      next.delete(messageIndex);
      return next;
    });
  }, []);

  return {
    storeImage,
    getImage,
    clearImages,
    removeImage,
    hasImages: generatedImages.size > 0,
  };
}
